<template>
  <div class="mobile_brief" @touchmove="handleTouchMove">
    <TopInside theme_="light" @goScroll ='goScroll' :click_menu = 'click_menu' ></TopInside>
    <img
      class="mobile_inside"
      src="../../../static/mobile/brief_0.jpg"
      alt=""
    />
    <div :class="['mobile_menu_con',fixed?'menu_fixed':'']">
      <div class="mobile_menu">
        <div
          @click="menuActive(item)"
          class="mobile_menu_item"
          v-for="(item, i) in menu"
          :key="i"
        >
          {{ item.name }}
        </div>
        <div class="line" :style="{left: left}"></div>
      </div>
    </div>

    <div id="brief_title_0" class="mobile_company" style="padding-top: 4.5rem;">
      <div class="mobile_brief_title" style="margin-bottom: 2.1rem">
        公司简介
      </div>
      <p>
        鼎函科技有限公司始创于2019年。公司创立以来，响应国家"放管服"号
        召，落实优化营商环境举措，促进银行、保险、担保金融产品的全线上
        化应用，提高效率降低企业成本，有效助力企业减负。根据客户需求提
        供专业定制软件产品、大数据服务运维、系统软件开发等业务。<br /><br />鼎函科技始终秉持"鼎力诚信、邀函即达"的理念，让数据多跑腿，让客
        户少走路的服务宗旨。以"诚信、专业、有社会责任感的科技公司"为发
        展目标，始终贯彻"诚信、合作、创新、卓越"的企业精神。
      </p>
      <video
      :src="video_url"
      controls
      poster="../../../static/other/jianjie.jpg"
      width="100%"
    >
  </video>
    </div>
    <div id="brief_title_1" style="padding-top: 3.5rem;">
      <div
      
      class="mobile_company"
      style="background: #fbfbfb; padding-top: 2rem"
    >
      <div class="mobile_brief_title" style="margin-bottom: 2.1rem">
        平台优势
      </div>
      <p>
        “鼎函电子保函服务平台”
        以国家信用大数据创新中心的公开数据为基础，运用独有保函科技技术满足不同客户的差
        异化需求，具有“快速、精准、灵活”的优势。<br /><br />
        打破线下保函出函流程长、小金额保函业务难受理的服务瓶颈，通过
        模块组合式平台架构，以完善的体系和标准化的服务连接招投标平台、
        保险、银行、担保等机构，结合区块链、大数
        据等数字技术保证电子保函的真实性，为客户节约大量时间成本、运营成本，切实减轻企业负担。
      </p>
    </div>
    </div>
    
    <div id="brief_title_2" class="mobile_server">
      <div style="width: 23.43rem; height: 17.25rem; position: relative">
        <img src="../../../static/mobile/brief_1.png" alt="" />
        <div
          class="mobile_brief_title"
          style="
            width: 100%;
            height: 17.25rem;
            line-height: 17.25rem;
            position: absolute;
            top: 0;
            color: #fbfbfb;
            background: rgba(0, 0, 0, 0.2);
          "
        >
          服务团队
        </div>
      </div>

      <div class="mobile_server_item">
        <div class="mobile_server_title">客户服务部</div>
        <p>
          鼎函科技于2020年正式建立客户服务部，核心人员主要来源于银行，保险等客服专业岗位，2023年组建数据服务中心，并开通400服务热线，目前有专业团队服务于线上保函业务
        </p>
      </div>
      <div class="mobile_server_item" style="background: #848484">
        <div class="mobile_server_title" style="text-align: right">
          数据服务中心
        </div>
        <p>
          数据服务中心致力于电子保函行业前沿探索与研究，为鼎函科技的客户提供全套解决方案，包括行业生态研究，产品开发，技术开发，大数据应用等
        </p>
      </div>
    </div>
    <div id="brief_title_3" class="mobile_qual">
      <div
        class="mobile_brief_title"
        style="padding-top:3.5rem;margin-bottom: 2.1rem; color: #fefefe"
      >
        公司资质
      </div>
      <Qual></Qual>
    </div>
  </div>
</template>

<script>
import TopInside from "./TopInside.vue";
import Qual from "./Qual.vue";

export default {
  name: "",
  mixins: [],
  components: {
    TopInside,
    Qual,
  },
  props: {},
  data() {
    return {
      menu: [
        { name: "公司简介", i: "0" },
        { name: "平台优势", i: "1" },
        { name: "服务团队", i: "2" },
        { name: "公司资质", i: "3" },
      ],
      fixed:false,
      left:0,
      video_url:'https://obs-db-guarantee.obs.myhuaweicloud.com/insurance/yanshi/%E5%AE%89%E8%B4%A3%E9%99%A9/vvvv.mp4',
      click_menu:false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
   
  },
  methods: {
    menuActive(item) {
      this.click_menu = true
      let element = document.getElementById("brief_title_" + item.i);
      element.scrollIntoView({
        behavior: "smooth",
      });
      this.left = (item.i)*25 +'%'
    },
    goScroll(val){
      this.fixed = val
    },
    handleTouchMove (event) {
      // console.log('touchmove',event)
      
    },
  },
};
</script>

<style scoped >
.mobile_brief {
  width: 100%;
  min-height: 100vh;
  background: #fefefe;
  overflow-x: hidden;
  color: #5f6464;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile_inside {
  width: 100%;
}
.mobile_menu_con {
  width: 100%;
  position: relative;
  height: 2.3rem;
  background: red;
}
.mobile_menu {
  width: 100%;
  display: flex;
  font-size: 0.8rem;
  height: 2.3rem;
  background: rgb(227, 227, 227);
  position: absolute;
  top: 0;
  left: 0;
}
.mobile_menu_item {
  height: 100%;
  flex-grow: 1;
  text-align: center;
  line-height: 2rem;
}
.line {
  background: #0052d9;
  width: 25%;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
  transition: 0.2s ease-out;

}
.mobile_company {
  padding: 0.8rem 0.625rem;
  box-sizing: border-box;
  width: 21.5rem;
  margin-top: 2.5rem;
}
.mobile_brief_title {
  font-size: 1.25rem;
  font-style: italic;
  color: #2a2e2e;
  width: 100%;
  text-align: center;
}
.mobile_company p {
  line-height: 1.5rem;
  margin-bottom: 2rem;
}
.mobile_server {
  width: 100%;
  /* margin-top: 3.5rem; */
  padding-top: 3.5rem;
}
.mobile_server img {
  width: 100%;
  height: 100%;
}
.mobile_brief_img {
  width: 23.43rem;
}
.mobile_server_title {
  width: 100%;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}
.mobile_server_item {
  width: 100%;
  background: #4d9eec;
  color: #fefefe;
  padding: 1rem 1rem;
  box-sizing: border-box;
}
.mobile_qual {
  background: rgb(26, 56, 98);
  padding: 1.87rem 0 3.5rem 0;
  width: 100%;
  margin-top: 3.5rem;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.menu_fixed{
  position: fixed;
  top: 2.4rem;
  left: 0;
  right: 0;
  z-index: 1998;
}
</style>
